import { createSelector } from 'reselect'

const select = (state) => state.callControl

const selectSessionId = createSelector(
  select,
  (callControl) => callControl.sessionId
)

const selectStartTime = createSelector(
  select,
  (callControl) => callControl.startTime
)

const selectIsStarted = createSelector(
  selectStartTime,
  (startTime) => startTime !== null
)

const selectShowModal = createSelector(
  select,
  (callControl) => callControl.showModal
)

const selectCallDuration = createSelector(
  select,
  (callControl) => callControl.callDuration
)

const selectAppId = createSelector(select, (callControl) => callControl.appId)

export {
  selectSessionId,
  selectIsStarted,
  selectStartTime,
  selectShowModal,
  selectCallDuration,
  selectAppId
}
